import React, { FC } from "react";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { Dropdown } from "@evergis/ui";

import { useClassificationQueryParams } from "../../../../hooks/location/useClassificationQueryParams";
import { useClassifyByAttribute } from "../../hooks/useClassifyByAttribute";
import { getClassificationField, getClassificationParameter } from "../../../../ducks/classification/selectors";
import { useClassificationSegment } from "../../../Dialogs/Classification/hooks/useClassificationSegment";

export const ClassificationAttribute: FC = () => {
  const { t } = useTranslation("common");
  const { attributeName, parameter: queryParameter } = useClassificationQueryParams();
  const classificationSegment = useClassificationSegment();
  const field = useSelector(getClassificationField);
  const parameter = useSelector(getClassificationParameter);
  const [attributeOptions, selectAttribute] = useClassifyByAttribute(
    classificationSegment?.parameter || parameter || queryParameter,
  );

  return (
    <Dropdown
      value={classificationSegment?.field || field || attributeName}
      label={t("classification.byAttribute")}
      placeholder={t("classification.attribute")}
      width={"16.5rem"}
      zIndex={120}
      options={attributeOptions}
      onChange={selectAttribute}
    />
  );
};
